module.exports = __webpack_public_path__ + "r-v3/img/thickness_blue.8971c0ce.svg";